import { FC, useEffect } from "react";
import ROUTES from "../../routes";
import Breadcrumb from "../../Common/Breadcrumb";
import { Accordion } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { faqs } from "../../data/faqs";

const FAQs: FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadCrumbData = [
    {
      title: "Home",
      path: ROUTES.HOME,
    },
    {
      title: "FAQs",
      path: "#",
    },
  ];

  return (
    <>
      <Helmet>
        <title>FAQ's | SkyAzul</title>
        <meta property="og:title" content="FAQ | SkyAzul" />
        <meta
          property="og:description"
          content="Page dedicated to frequently asked questions that relate to our services"
        />
        <meta
          property="og:url"
          content={`${window.location.origin}${ROUTES.FAQ}`}
        />
      </Helmet>
      <Breadcrumb breadcrumbs={breadCrumbData} pageTitle="FAQs" />
      <div className="container pb-5">
        <div className="row mt-3">
          <div className="col-md-12">
            <Accordion defaultActiveKey="1" className="custom-accordion">
              {faqs.map((dataItem) => (
                <Accordion.Item eventKey={String(dataItem.id)} key={dataItem.id}>
                  <Accordion.Header>{dataItem.question}</Accordion.Header>
                  <Accordion.Body className="px-4 py-3">
                    <div
                      className="custom-part-number-table"
                      dangerouslySetInnerHTML={{
                        __html: dataItem.answer,
                      }}
                    ></div>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQs;
